import { Button, Grid, Tooltip, Typography } from '@mui/material';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import './guarantor.css';
import CustomisedButton from '../../../components/button/button';
import { Formik } from 'formik';
import { IAddCustomerInfoForInquiryRequest, IDropDownResponse, IGetFormRejectReasonsResponse } from '../../../models/registration.model';
import CustomisedDatePicker from '../../../components/datePicker/datePicker';
import CustomisedTextField from '../../../components/textField/textField';
import { newDate } from '@persian-tools/persian-mobile-datepicker';
import { ReactHTMLElement, useEffect, useRef, useState } from 'react';
import CustomisedTitleFont14 from '../../../components/title/titleFont14';
import CustomisedCardLine from '../../../components/card/cardLine';
import { title } from 'process';
import CustomisedCardLoad from '../../../components/card/cardLoad';
import CustomisedCardUpload from '../../../components/card/cardUpload';
import { IUploadFile } from '../../../components/uploader/IUploadFile';
import CustomisedCardMultiImage from '../../../components/card/cardMultiImage';
import CustomisedDropDown from '../../../components/dropDown/dropDown';
import { IGuarantorContainer } from '../../navigationButtonComponents/guarantorContainer/TGuarantorContainer';
import { CheckCompletionResponse, IAddFileRequeste, IDeleteFileRequeste, IDeleteGuarantorRequest, IGetGuarantorAdditionalInfoResponse, IGetGuarantorChequeRequest, IGetGuarantorsResponse, IUpdateGuarantorAdditionalInfoRequest } from '../../../models/guarantor.model';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useMutation, useQueryClient } from 'react-query';
import { addFile, CheckCompletion, deleteFile, getGuarantorAdditionalInfo, updateGuarantorAdditionalInfo } from '../../../services/guarantor.service';
import { ApiResultModel, IDocument } from '../../../models/common.model';
import { IDocumentResponse } from '../../../models/identity.model';
import { getIncomeRangeOptions } from '../../../services/income.service';
import { IDocumentPropertiesResponse } from '../../../models/income.model';
import { DOCUMENT_TYPES, INCOME_RANGE } from '../../../config/cacheKey';
import { IDocumentTypeHints } from '../../../models/basicInformation.model';
import { toArray, values } from 'lodash';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useAppBar } from '../../../components/appBar/appBarContext';
import { changeRouteType, getpervInnerState } from '../../../redux/handleBackBtn/handleBackBtnSlice';
import GuarantorCompletionSkeleton from './guarantorCompletionSkeleton';
import { getFormRejectReasons } from '../../../services/registration.service';
import CustomisedErrorCard from '../../../components/card/errorCard';
import MailBox from '../../../components/icons/MailBox';
import PersonIcon from '@mui/icons-material/Person';
import BadgeIcon from '@mui/icons-material/Badge';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

export default function GuarantorCompletion({ setStep, setInnerState, referenceKey }: IGuarantorContainer) {
    const [file, setFile] = useState<IUploadFile>();
    const [incomeRange, setIncomeRange] = useState<IDropDownResponse[]>([]);
    const [incomeRangeOption, setIncomeRangeOption] = useState<IDropDownResponse>();
    const [incomeRangeOptionTitle, setIncomeRangeOptionTitle] = useState<string>();
    const [incomeRangeOptionId, setIncomeRangeOptionId] = useState<number>();
    const [nationalCard, setNationalCard] = useState<IDocumentResponse>();
    const [residenceDocuments, setResidenceDocuments] = useState<IDocumentResponse[]>([]);
    const [guarantorIncomes, setGuarantorIncomes] = useState<IDocumentResponse[]>([]);
    const [delImage, setDelImage] = useState<boolean>(false);
    const [addMultiImage, setAddMultiImage] = useState<boolean>(false);
    const [valNationalCard, setValNationalCard] = useState<IDocumentTypeHints>();
    const [valResidenceDocuments, setValResidenceDocuments] = useState<IDocumentTypeHints>();
    const [valGuarantorIncomes, setValGuarantorIncomes] = useState<IDocumentTypeHints>();
    const [guarantorInfo, setGuarantorInfo] = useState<any[]>([]);
    const [rejectReasons, setRejectReasons] = useState<string[]>([]);
    const [checkBySetad, setCheckBySetad] = useState(false);
    const [documentTypeReject, setDocumentTypeReject] = useState<string[]>([]);
    const [arrayImg, setArrayImg] = useState<any[]>([]);
    const [fileUrlDel, setFileUrlDel] = useState<any[]>([]);
    const [jobArrayImg, setJobArrayImg] = useState<any[]>([]);
    const [jobFileUrlDel, setJobFileUrlDel] = useState<any[]>([]);
    const [isChequeCompleted, setIsChequeCompleted] = useState(false);
    const guarantorKey = useSelector(
        (state: RootState) => state.guarantorInfo.guarantorKey
    );

    const buttonRef = useRef<any>(null)
    const queryClient = useQueryClient();
    const { setHeader } = useAppBar();
    const dispatch = useDispatch();

    const randomKeyForDispatch = Math.random();
    useEffect(() => {
        let additionalInfo = {} as IDeleteGuarantorRequest;
        additionalInfo.referenceKey = referenceKey!;
        additionalInfo.key = guarantorKey;
        // GetGuarantorAdditionalInfoMutate(additionalInfo);
        // setNationalCard(undefined);
        setDelImage(false);
    }, [delImage]);
    useEffect(() => {
        let additionalInfo = {} as IDeleteGuarantorRequest;
        additionalInfo.referenceKey = referenceKey!;
        additionalInfo.key = guarantorKey;
        // GetGuarantorAdditionalInfoMutate(additionalInfo);
        setAddMultiImage(false);
        GetRejectReasonsResidenceMutate({
            referenceKey: referenceKey!,
            form: 'Guarantors'
        })
    }, [addMultiImage]);

    useEffect(() => {
        let newArray = arrayImg?.filter((item: any) =>
            item.fileUrl !== fileUrlDel);
        setArrayImg(newArray);
    }, [fileUrlDel]);

    useEffect(() => {
        let newArray = jobArrayImg?.filter((item: any) =>
            item.fileUrl !== jobFileUrlDel);
        setJobArrayImg(newArray);
    }, [jobFileUrlDel]);


    useEffect(() => {
        if (file !== undefined) {
            const registerDocument = {} as IAddFileRequeste;
            registerDocument.documentType = 'GuarantorNationalCardFront';
            registerDocument.guarantorKey = guarantorKey;
            registerDocument.referenceKey = referenceKey!;
            registerDocument.file = file?.file!;
            AddFileMutate(registerDocument);
        }

    }, [file]);
    let array: any[] = [];
    useEffect(() => {
        setHeader('اطلاعات تکمیلی ضامن', 'guarantor');
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: 'guarantorIntroduce' + randomKeyForDispatch }));
        let additionalInfo = {} as IDeleteGuarantorRequest;
        additionalInfo.referenceKey = referenceKey!;
        additionalInfo.key = guarantorKey;
        GetGuarantorAdditionalInfoMutate(additionalInfo);
        let checkComplete = {} as IGetGuarantorChequeRequest;
        checkComplete.guarantorKey = guarantorKey;
        checkComplete.referenceKey = referenceKey!;
        CheckCompletionMutate(checkComplete);
        GetIncomeRangeOptionsMutate();
        GetRejectReasonsResidenceMutate({
            referenceKey: referenceKey!,
            form: 'Guarantors'
        })
    }, [])

    const { mutate: GetRejectReasonsResidenceMutate } = useMutation(
        getFormRejectReasons,
        {
            onSuccess: (data: IGetFormRejectReasonsResponse[]) => {
                if (data) {
                    let documentTypeRejectReasons: any[] = [];
                    let documentType: any[] = [];
                    let rejectReason: IGetFormRejectReasonsResponse[];
                    rejectReason = data?.filter((item: any) => item.guarantorKey === guarantorKey);
                    rejectReason[0]?.documentTypeRejectReasons?.map((val: any) => {
                        documentType.push(val.documentType)
                        documentTypeRejectReasons.push(val.rejectReasons)
                    }
                    )
                    setRejectReasons(documentTypeRejectReasons);
                    setDocumentTypeReject(documentType);
                    setCheckBySetad(data[0]?.checkBySetad);
                }
            },
        }
    );

    const { mutate: GetIncomeRangeOptionsMutate } = useMutation(
        getIncomeRangeOptions,
        {
            onSuccess: (data: IDocumentPropertiesResponse[]) => {
                if (data) {
                    setIncomeRange(data)
                }
            },
        }
    );
    const { mutate: CheckCompletionMutate } = useMutation(
        CheckCompletion,
        {
            onSuccess: (data: CheckCompletionResponse) => {
                if (data) {
                    setIsChequeCompleted(data.isChequeCompleted);
                }
            },
        }
    );
    const { mutate: UpdateGuarantorAdditionalInfoMutate } = useMutation(
        updateGuarantorAdditionalInfo,
        {
            onSuccess: (data: boolean) => {
                if (data) {
                    isChequeCompleted ? setInnerState!('guarantorIntroduce') :
                        setInnerState!('guarantorRegister');
                }
            },
        }
    );
    const { mutate: AddFileMutate } = useMutation(
        addFile,
        {
            onSuccess: (data: ApiResultModel<IDocument>) => {
                if (data.isSuccess) {
                    if (data.data) {
                        setNationalCard(data.data);
                        GetRejectReasonsResidenceMutate({
                            referenceKey: referenceKey!,
                            form: 'Guarantors'
                        })
                    }
                }
            },
        }
    );


    const { mutate: GetGuarantorAdditionalInfoMutate, isLoading: LoadingGuarantorAdditionalInfo } = useMutation(
        getGuarantorAdditionalInfo,
        {
            onSuccess: (data: IGetGuarantorAdditionalInfoResponse) => {
                if (data) {
                    array.push({
                        title: <><PersonIcon sx={{ marginLeft: "5px" }} />نام و نام خانوادگی</>
                        , value: data?.firstName + ' ' + data?.lastName
                    });
                    array.push({
                        title: <><BadgeIcon sx={{ marginLeft: "5px" }} />کد ملی</>
                        , value: data?.nationalCode
                    });
                    array.push({ title: <><CalendarMonthIcon sx={{ marginLeft: "5px" }} />تاریخ تولد</>, value: data?.birthDatePersian });
                    array.push({ title: <><PhoneIphoneIcon sx={{ marginLeft: "5px" }} />شماره موبایل</>, value: data?.mobileNumber });
                    array.push({
                        title: <><MailBox sx={{ marginLeft: "5px", fontSize: "20px", marginBottom: "5px" }} />کد پستی</>
                        , value: data?.postalCode
                    });
                    setGuarantorInfo(array);
                    setNationalCard(data.guarantorNationalCardFront);
                    setResidenceDocuments(data.guarantorResidenceDocuments);
                    setArrayImg(data.guarantorResidenceDocuments);
                    setJobArrayImg(data.guarantorIncomes);
                    setGuarantorIncomes(data.guarantorIncomes);
                    setValNationalCard(JSON.parse(localStorage.getItem(DOCUMENT_TYPES)!)?.find((x: any) =>
                        x.documentType === 'GuarantorNationalCardFront'
                    ))
                    setValResidenceDocuments(JSON.parse(localStorage.getItem(DOCUMENT_TYPES)!)?.find((x: any) =>
                        x.documentType === 'GuarantorResidenceDocument'
                    ))
                    setValGuarantorIncomes(JSON.parse(localStorage.getItem(DOCUMENT_TYPES)!)?.find((x: any) =>
                        x.documentType === 'GuarantorIncome'
                    ))
                    setIncomeRangeOptionId(data.incomeRangeOptionId ? data.incomeRangeOptionId : queryClient.getQueryData(INCOME_RANGE));
                    setIncomeRangeOptionTitle(data.incomeRangeOptionTitle);
                }
            },
        }
    );
    useEffect(() => {
        setIncomeRangeOptionTitle(incomeRangeOption?.title);
        setIncomeRangeOptionId(incomeRangeOption?.id);
        queryClient.setQueryData(INCOME_RANGE, incomeRangeOption?.id);
    }, [incomeRangeOption]);


    const setChildValue = (childValues: any) => {
        setNationalCard(undefined);
    };
    const [openTooltip, setOpenTooltipValue] = useState(null);
    let hasValueComment = valResidenceDocuments?.hints?.length! > 0 ? 0 : 1;
    const toggleClick = (index: any) => {
        setOpenTooltipValue(openTooltip === index ? null : index);
    };
    if (LoadingGuarantorAdditionalInfo) {
        return <GuarantorCompletionSkeleton />
    }
    return (
        <>
            <div className="container-height-drawer">
                <div className='content-container'>
                    <div className='drawer-content'>
                        <Formik
                            initialValues={{} as IUpdateGuarantorAdditionalInfoRequest}
                            onSubmit={(values: IUpdateGuarantorAdditionalInfoRequest) => {
                                values.referenceKey = referenceKey!;
                                values.key = guarantorKey!;
                                values.incomeRangeOptionId = incomeRangeOptionId!;
                                UpdateGuarantorAdditionalInfoMutate(values)
                            }}
                        >
                            {({
                                handleSubmit,
                            }) => (
                                <form
                                    onSubmit={handleSubmit}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSubmit();
                                        }
                                    }}
                                >
                                    <div
                                        className="text-center"
                                        style={{
                                            bottom: '10vh',
                                        }}
                                    >
                                        {rejectReasons.length > 0 ? <Grid
                                            item xs={12} style={{ textAlign: 'right', marginBottom: '20px' }} className='!pt-5'
                                        >
                                            <CustomisedErrorCard titleList={rejectReasons} />
                                        </Grid> : ""

                                        }
                                        <Grid
                                            container
                                            className="row centerClass"
                                        // spacing={2}
                                        >
                                            <Typography style={{ paddingBottom: '0.6rem' }}>
                                                <CustomisedTitleFont14 title={'اطلاعات ضامن'} />
                                            </Typography>
                                            <Grid item xs={12} style={{ textAlign: 'right' }}>
                                                <CustomisedCardLine
                                                    itemList={guarantorInfo}
                                                />
                                            </Grid>

                                            <Grid item xs={12} style={{ textAlign: 'right', marginBottom: '10px' }} className='!pt-5'>
                                                {
                                                    nationalCard === null || nationalCard === undefined ?
                                                        <CustomisedCardUpload
                                                            title={valNationalCard?.title ? valNationalCard.title : 'روی کارت ملی'}
                                                            setFileSelected={setFile}
                                                            comment={valNationalCard?.hints?.length! > 100
                                                                ? toArray(valNationalCard?.hints?.slice(0, 100) + '...') : toArray(valNationalCard?.hints)}
                                                            fileExtensions={valNationalCard?.fileExtensions}
                                                            maxSizeKb={valNationalCard?.maxSizeKb}
                                                            rejected={rejectReasons?.length > 0 ? documentTypeReject?.filter((item: any) =>
                                                                item === 'GuarantorNationalCardFront'
                                                            ).length > 0 ? true : false : undefined}
                                                        />
                                                        :
                                                        <CustomisedCardLoad
                                                            title={
                                                                nationalCard?.documentTypeTitle!
                                                            }
                                                            fileSelected={
                                                                nationalCard?.fileUrl
                                                            }
                                                            // documentId={
                                                            //     nationalCard?.
                                                            // }
                                                            setDelImage={
                                                                setDelImage
                                                            }
                                                            setChildValue={
                                                                setChildValue
                                                            }
                                                            fileArray={nationalCard}
                                                            serviceName={
                                                                deleteFile
                                                            }
                                                            serviceRequestObj={
                                                                {
                                                                    referenceKey: referenceKey!,
                                                                    fileId: nationalCard.fileId!,
                                                                    guarantorKey: guarantorKey
                                                                } as IDeleteFileRequeste
                                                            }
                                                            comment={valNationalCard?.hints?.length! > 100 ? toArray(valNationalCard?.hints?.slice(0, 100) + '...') : toArray(valNationalCard?.hints)}
                                                            fileExtensions={valNationalCard?.fileExtensions}
                                                            maxSizeKb={valNationalCard?.maxSizeKb}
                                                            rejected={rejectReasons?.length > 0 ? documentTypeReject?.filter((item: any) =>
                                                                item === nationalCard?.documentType!
                                                            ).length > 0 ? true : false : undefined}
                                                            checkBySetad={checkBySetad}
                                                            fileType={nationalCard?.fileType}
                                                        />
                                                }
                                            </Grid>
                                            <Typography >
                                                <Tooltip
                                                    onClose={() => toggleClick(null)}
                                                    open={openTooltip === hasValueComment}
                                                    placement="bottom-start"
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                width: '165px',
                                                                textAlign: 'center',
                                                                fontSize: '11px',
                                                                // marginRight: '11vh',
                                                                // marginLeft: '1vh',
                                                            },
                                                        },
                                                    }}
                                                    title={valResidenceDocuments?.hints?.length! > 100 ? toArray(valResidenceDocuments?.hints?.slice(0, 100) + '...')
                                                        : toArray(valResidenceDocuments?.hints)}
                                                    arrow
                                                >
                                                    <Button className="!text-sm !font-bold primaryColorLight-900 mb-1 items-center buttonCard"
                                                        onClick={() => toggleClick(0)} style={{ background: 'transparent' }} disableTouchRipple>
                                                        {'اطلاعات سکونتی'}
                                                        <InfoOutlinedIcon
                                                            className="primaryColorLight mr-2"
                                                            style={{
                                                                width: '17px',
                                                                height: '17px',
                                                            }}
                                                        />
                                                    </Button>
                                                </Tooltip>
                                            </Typography>
                                            <Grid item xs={12} style={{ textAlign: 'right' }} className='!pt-2 !pb-5' >
                                                <CustomisedCardMultiImage
                                                    title={"اطلاعات سکونتی"}
                                                    serviceNameDel={
                                                        deleteFile
                                                    }
                                                    serviceNameAdd={
                                                        addFile
                                                    }
                                                    serviceRequestObjDel={{
                                                        referenceKey: referenceKey,
                                                        guarantorKey: guarantorKey,
                                                    } as IDeleteFileRequeste}
                                                    serviceRequestObjAdd={{
                                                        referenceKey: referenceKey,
                                                        guarantorKey: guarantorKey,
                                                        documentType: 'GuarantorResidenceDocument'
                                                    } as IAddFileRequeste}
                                                    documentArray={arrayImg}
                                                    setDelImage={
                                                        setDelImage
                                                    }
                                                    setAddMultiImage={
                                                        setAddMultiImage
                                                    }
                                                    comment={valResidenceDocuments?.hints?.length! > 100 ? toArray(valResidenceDocuments?.hints?.slice(0, 100) + '...')
                                                        : toArray(valResidenceDocuments?.hints)}
                                                    fileExtensions={valResidenceDocuments?.fileExtensions}
                                                    rejected={rejectReasons?.length > 0 ? documentTypeReject?.filter((item: any) =>
                                                        item === 'GuarantorResidenceDocument'
                                                    ).length > 0 ? true : false : undefined}
                                                    setArrayImg={setArrayImg}
                                                    setFileUrlDel={setFileUrlDel}
                                                    checkBySetad={checkBySetad}
                                                    maxSizeKb={valResidenceDocuments?.maxSizeKb}
                                                />
                                            </Grid>
                                            <Typography >
                                                <Tooltip
                                                    onClose={() => toggleClick(null)}
                                                    open={openTooltip === hasValueComment}
                                                    placement="bottom-start"
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                width: '165px',
                                                                textAlign: 'center',
                                                                fontSize: '11px',
                                                                // marginRight: '11vh',
                                                                // marginLeft: '1vh',
                                                            },
                                                        },
                                                    }}
                                                    title={valResidenceDocuments?.hints?.length! > 100 ? toArray(valResidenceDocuments?.hints?.slice(0, 100) + '...')
                                                        : toArray(valResidenceDocuments?.hints)}
                                                    arrow
                                                >
                                                    <Button className="!text-sm !font-bold primaryColorLight-900 mb-1 items-center buttonCard"
                                                        onClick={() => toggleClick(0)} style={{ background: 'transparent' }} disableTouchRipple>
                                                        {'اطلاعات درآمدی'}
                                                        <InfoOutlinedIcon
                                                            className="primaryColorLight mr-2"
                                                            style={{
                                                                width: '17px',
                                                                height: '17px',
                                                            }}
                                                        />
                                                    </Button>
                                                </Tooltip>
                                            </Typography>
                                            <Grid
                                                item
                                                xs={12}
                                                className='!mt-2'
                                                style={{
                                                    padding: '0px',
                                                }}
                                            >
                                                <CustomisedDropDown
                                                    title={
                                                        incomeRangeOptionTitle
                                                            ? incomeRangeOptionTitle
                                                            : incomeRangeOption
                                                                ? incomeRangeOption.title
                                                                : 'میانگین درآمد'
                                                    }
                                                    options={incomeRange!}
                                                    label="میانگین درآمد"
                                                    setSelectedItem={setIncomeRangeOption}
                                                    isSelected={incomeRangeOptionTitle ? true : false}
                                                    rejected={rejectReasons?.length > 0 ? documentTypeReject?.filter((item: any) =>
                                                        item === 'GuarantorIncome'
                                                    ).length > 0 ? false : true : undefined}
                                                ></CustomisedDropDown>
                                            </Grid>
                                            <Grid item xs={12} style={{ textAlign: 'right' }} className='!pt-5 !pb-5' >
                                                <CustomisedCardMultiImage
                                                    title={"اطلاعات درآمدی"}
                                                    serviceNameDel={
                                                        deleteFile
                                                    }
                                                    serviceNameAdd={
                                                        addFile
                                                    }
                                                    serviceRequestObjDel={{
                                                        referenceKey: referenceKey,
                                                        guarantorKey: guarantorKey,
                                                    } as IDeleteFileRequeste}
                                                    serviceRequestObjAdd={{
                                                        referenceKey: referenceKey,
                                                        guarantorKey: guarantorKey,
                                                        documentType: 'GuarantorIncome'
                                                    } as IAddFileRequeste}
                                                    // documentArray={guarantorIncomes}
                                                    documentArray={jobArrayImg}
                                                    setDelImage={
                                                        setDelImage
                                                    }
                                                    setAddMultiImage={
                                                        setAddMultiImage
                                                    }
                                                    comment={valGuarantorIncomes?.hints?.length! > 100 ? toArray(valGuarantorIncomes?.hints?.slice(0, 100) + '...') :
                                                        toArray(valGuarantorIncomes?.hints)}
                                                    fileExtensions={valGuarantorIncomes?.fileExtensions}
                                                    rejected={rejectReasons?.length > 0 ? documentTypeReject?.filter((item: any) =>
                                                        item === 'GuarantorIncome'
                                                    ).length > 0 ? true : false : undefined}
                                                    setArrayImg={setJobArrayImg}
                                                    setFileUrlDel={setJobFileUrlDel}
                                                    checkBySetad={checkBySetad}
                                                    maxSizeKb={valGuarantorIncomes?.maxSizeKb}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className="pt-5" >
                                                    <Button
                                                        type="submit"
                                                        ref={buttonRef}
                                                        style={{ display: "none" }}
                                                    ></Button>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                    <div className="py-5">
                        <CustomisedButton
                            onClick={() => {
                                if (buttonRef.current) {
                                    buttonRef.current.click()
                                }

                            }}
                            title='ثبت و ادامه'
                            type='button'
                            disable={
                                incomeRangeOptionId !== null && incomeRangeOptionId !== undefined
                                    && jobArrayImg !== null && jobArrayImg?.length > 0 &&
                                    arrayImg !== null && arrayImg?.length > 0
                                    && nationalCard !== null && nationalCard !== undefined ? false : true
                            }

                        />

                    </div>
                </div>
            </div>
        </>
    );
}
